import React from 'react';
import { AiOutlineHtml5, AiOutlineFire } from "react-icons/ai";
import { DiCss3, DiNodejs } from "react-icons/di";
import { SiMongodb, SiExpress, SiReactos, SiSkillshare } from "react-icons/si";
import { TbBrandJavascript } from "react-icons/tb";

const Skills = () => {
    return (

        <div className="bg-gray-900 mt-8">
            <div className=' flex flex-1  font-bold text-4xl text-center p-6 items-center justify-center gap-2 text-slate-200'>
                <span><SiSkillshare></SiSkillshare></span>
                <h1 >Skills</h1>
            </div>

            <div className="relative px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                <div className="absolute inset-x-0 top-0 items-center justify-center hidden overflow-hidden md:flex md:inset-y-0">
                    <svg
                        viewBox="0 0 88 88"
                        className="w-full max-w-screen-xl text-gray-800"
                    >
                        <circle
                            fill="currentColor"
                            fillOpacity="0.4"
                            cx="44"
                            cy="44"
                            r="15.5"
                        />
                        <circle
                            fillOpacity="0.1"
                            fill="currentColor"
                            cx="44"
                            cy="44"
                            r="44"
                        />
                        <circle
                            fillOpacity="0.1"
                            fill="currentColor"
                            cx="44"
                            cy="44"
                            r="37.5"
                        />
                        <circle
                            fillOpacity="0.1"
                            fill="currentColor"
                            cx="44"
                            cy="44"
                            r="29.5"
                        />
                        <circle
                            fillOpacity="0.1"
                            fill="currentColor"
                            cx="44"
                            cy="44"
                            r="22.5"
                        />
                    </svg>
                </div>
                <div className="relative grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200">
                        <AiOutlineHtml5></AiOutlineHtml5>
                        <p className="font-semibold ">
                            HTML
                        </p>
                    </div>
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200">
                        <DiCss3></DiCss3>
                        <p className="font-semibold ">
                            CSS
                        </p>
                    </div>
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200">
                        <TbBrandJavascript></TbBrandJavascript>
                        <p className="font-semibold ">
                            Javascript
                        </p>
                    </div>
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200 ">
                        <SiReactos></SiReactos>
                        <p className="font-semibold ">
                            Reactjs
                        </p>
                    </div>
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200">
                        <SiMongodb></SiMongodb>
                        <p className="font-semibold ">
                            MongoDB
                        </p>
                    </div>
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200">
                        <DiNodejs></DiNodejs>
                        <p className="font-semibold ">
                            Nodejs
                        </p>
                    </div>
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200">
                        <SiExpress></SiExpress>
                        <p className="font-semibold ">
                            Express
                        </p>
                    </div>
                    <div className="px-10 py-20 flex flex-col items-center justify-center text-center transition duration-300 transform bg-gray-900 rounded shadow-2xl hover:scale-105 md:shadow-xl hover:shadow-2xl text-gray-200">
                        <AiOutlineFire></AiOutlineFire>
                        <p className="font-semibold ">
                            Firebase
                        </p>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Skills;